import React, { createContext, useContext } from 'react';
import { useReducedMotion } from '../hooks/useReducedMotion';

const MotionContext = createContext({
  prefersReducedMotion: false,
  toggleReducedMotion: () => {},
  resetToSystem: () => {},
});

export const MotionProvider = ({ children }) => {
  const motionState = useReducedMotion();

  return (
    <MotionContext.Provider value={motionState}>
      {children}
    </MotionContext.Provider>
  );
};

export const useMotion = () => useContext(MotionContext);

export default MotionContext;
